// Formats a date-only value (e.g. a DATE column) as a calendar date that's
// identical for every viewer, regardless of their device's timezone.
// The API returns DATE columns as full ISO timestamps at UTC midnight
// (e.g. "2026-07-27T00:00:00.000Z"). A pure calendar date has no time-of-day,
// so there's nothing meaningful to convert to Eastern here — instead we
// anchor the value at UTC midnight for the given Y/M/D and format it back
// out in UTC, which guarantees the same date renders everywhere. (Formatting
// with timeZone: 'America/New_York' here would actually shift the displayed
// date backwards by one for any viewer, since Eastern is behind UTC — the
// exact bug this file exists to avoid.)
export const formatDate = (str) => {
  if (!str) return '—';
  const datePart = String(str).slice(0, 10);
  const [y, m, d] = datePart.split('-').map(Number);
  if (!y || !m || !d) return '—';
  const date = new Date(Date.UTC(y, m - 1, d));
  return isNaN(date) ? '—' : date.toLocaleDateString('en-US', {
    year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC'
  });
};

// Formats a full timestamp (e.g. clock_session.started_at/ended_at) in
// Eastern Time, regardless of the viewer's own device timezone. Unlike
// formatDate, these values carry real time information, so converting them
// to a fixed zone is both meaningful and correct. America/New_York handles
// EST/EDT switching automatically.
export const formatTime = (str) => {
  if (!str) return '—';
  const d = new Date(str);
  return isNaN(d) ? '—' : d.toLocaleTimeString('en-US', {
    hour: 'numeric', minute: '2-digit', timeZone: 'America/New_York'
  });
};
